import { render, staticRenderFns } from "./TintStyles.vue?vue&type=template&id=5ba8170b&"
import script from "./TintStyles.vue?vue&type=script&lang=js&"
export * from "./TintStyles.vue?vue&type=script&lang=js&"
import style0 from "./TintStyles.vue?vue&type=style&index=0&id=5ba8170b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports